import type { ReactNode } from 'react';
import React, { Children } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { COLORS } from 'Components/utils/color/colors';
import { t } from 'Src/i18n';
import { ArrowButton } from 'Components/frameworks/arrow-button/ArrowButton';
import { SliderHandler } from 'Components/frameworks/slider-handler/SliderHandler';
type Props = {
  children: ReactNode;
  className?: string;
};
export const ContentSlideShow = ({ children, className }: Props) => {
  if (!Children.count(children)) {
    return null;
  }

  return (
    <SliderHandler hasKeyboardSupport hasLazyload hasSwipeSupport items={children}>
      {({
        hasControls,
        isNextControlDisabled,
        isPreviousControlDisabled,
        itemsNode,
        onNext,
        onPrevious,
      }) => (
        <div className={classnames('flex items-center justify-center gap-15', className)}>
          {hasControls && (
            <ArrowButton
              className={classnames('flex-none shadow-sm', {
                invisible: isPreviousControlDisabled,
              })}
              color={COLORS.WHITE}
              isDisabled={isPreviousControlDisabled}
              label={t('common.previous')}
              onClick={onPrevious}
            />
          )}
          {itemsNode}
          {hasControls && (
            <ArrowButton
              className={classnames('flex-none shadow-sm', {
                invisible: isNextControlDisabled,
              })}
              color={COLORS.WHITE}
              isDisabled={isNextControlDisabled}
              label={t('common.next')}
              onClick={onNext}
              rotation={180}
            />
          )}
        </div>
      )}
    </SliderHandler>
  );
};
